import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useStatementTableColumns } from '../../financialStatements/hooks/useStatementTableColumns'
import { useDriverDataTableColumns } from './useDriverDataTableColumns'
import { useCtxDimensions } from '../../dimension/queries/useCtxDimensions'
import { useCtxBudgetDrivers } from '../../budgetDrivers/queries/useCtxBudgetDrivers'

export const useDriverDataColumns = () => {
  const { t } = useTranslation()

  // Get the period columns from the statement table hook
  const statementColumns = useStatementTableColumns()

  // Fetch dimensions and budget drivers
  const { data: dimensions = [] } = useCtxDimensions()
  const { data: budgetDrivers = [] } = useCtxBudgetDrivers()

  // Create budget driver lookup map using formula.id as key (matches DriverData.formulaId)
  const budgetDriverMap = useMemo(() => {
    return new Map(budgetDrivers.map(d => [d.formula.id, d]))
  }, [budgetDrivers])

  // Create dimension lookup map
  const dimensionMap = useMemo(() => {
    const map = new Map(dimensions.map(d => [d.dimensionId, d.name]))
    // Add root dimension manually
    map.set('null', t('global:enterpriseLevel'))
    return map
  }, [dimensions, t])

  // Use the dedicated driver data table columns hook
  const columnDefs = useDriverDataTableColumns({
    columns: statementColumns,
    dimensionMap,
    budgetDriverMap
    // forecastCursor is now accessed via params.context.forecastCursor in the column defs
  })

  return {
    columnDefs,
    columns: statementColumns,
    budgetDriverMap,
    dimensionMap
  }
}
